import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, TableList, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { Attachments } from '~/components/Attachments/Attachments';
import { emptyCell } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { utils } from '~/utils';
import { VendorLineItem, CustomerLineItem } from './LineItem/LineItem';
import styles from './ScheduledInvoice.module.scss';
import { columnDefs, HeaderDateIndicator } from './ScheduledInvoice.utils';
const deprecatedTestIds = {
    ScheduledInvoiceTestIds: {
        Root: 'scheduled-invoice',
        IssueDate: 'scheduled-invoice-issue-date',
        DueOnDate: 'scheduled-invoice-due-on-date',
        RowsContainer: 'scheduled-invoice-rows-container',
        TotalAmountRow: 'total-amount-row'
    }
};
export const GetScheduledInvoiceTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
export default function ScheduledInvoice(props) {
    const { t: texts } = useLocaleKeys('pages.agreementMinisite.scheduledInvoice');
    const { ScheduledInvoiceTestIds } = useMemo(()=>GetScheduledInvoiceTID(), []);
    const ScheduledInvoiceTableRow = props.isVendor ? VendorLineItem : CustomerLineItem;
    return /*#__PURE__*/ _jsx(TableList.Provider, {
        variant: "minimal",
        columnDefs: columnDefs,
        justifyBetween: true,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            "data-testid": ScheduledInvoiceTestIds.Root(),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.infoRow,
                    children: [
                        /*#__PURE__*/ _jsx(HeaderDateIndicator, {
                            label: texts.issueDate(),
                            date: props.issueDate,
                            testId: ScheduledInvoiceTestIds.IssueDate()
                        }),
                        /*#__PURE__*/ _jsx(HeaderDateIndicator, {
                            label: texts.dueOn(),
                            date: props.paymentDate,
                            testId: ScheduledInvoiceTestIds.DueOnDate()
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(TableList.Header, {
                    className: styles.header,
                    bgColor: "darkGray",
                    items: columnDefs
                }),
                props.rowsProps.length ? /*#__PURE__*/ _jsxs("div", {
                    "data-testid": ScheduledInvoiceTestIds.RowsContainer(),
                    children: [
                        props.rowsProps.map((rowProps)=>/*#__PURE__*/ _jsx(ScheduledInvoiceTableRow, _object_spread_props(_object_spread({}, rowProps), {
                                addedLineItemId: props.addedLineItemId
                            }), rowProps.charge.id)),
                        /*#__PURE__*/ _jsx(TableList.Row, {
                            className: styles.footerRow,
                            items: [
                                emptyCell,
                                emptyCell,
                                {
                                    value: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph1",
                                        children: texts.subtotal()
                                    })
                                },
                                emptyCell,
                                {
                                    value: /*#__PURE__*/ _jsx(Typography, {
                                        weight: "normal",
                                        children: utils.formatDollarAmount(props.totalAmount)
                                    })
                                },
                                emptyCell,
                                emptyCell
                            ],
                            testId: ScheduledInvoiceTestIds.TotalAmountRow()
                        }),
                        props.attachments && props.isVendor && /*#__PURE__*/ _jsx(Box, {
                            className: styles.attachments,
                            children: /*#__PURE__*/ _jsx(Attachments, {
                                disableDownloadLinks: true,
                                files: props.attachments.files,
                                onRemove: props.attachments.onRemove
                            })
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraph1",
                    className: styles.empty,
                    children: [
                        "Services included in your next invoice will appear here.",
                        /*#__PURE__*/ _jsx("br", {}),
                        'You can add services by clicking on "Billing Control" at the top right.'
                    ]
                })
            ]
        })
    });
}
